module.exports = {
	BASE_URL: "https://apis.staging.sharechat.com",
	RECAPTCHA_SITE_KEY: "6Lftm7gUAAAAAMG4iGKUiKpbc6puvVpSmb6oWPQy"
};
